import { render, staticRenderFns } from "./label-filtration.vue?vue&type=template&id=91497a3a&scoped=true&"
import script from "./label-filtration.vue?vue&type=script&lang=js&"
export * from "./label-filtration.vue?vue&type=script&lang=js&"
import style0 from "./label-filtration.vue?vue&type=style&index=0&id=91497a3a&lang=scss&scoped=true&"
import style1 from "./label-filtration.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91497a3a",
  null
  
)

export default component.exports